<template>
    <div id="pwa-planning" class="mx-2">
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
	            <div class="intervention-details__card">
		            <p class="font-medium mb-2 text-sm">Planning d'intervention</p>
		            <md-divider class="mb-1 -mt-1 -mx-2"></md-divider>
		            <div class="py-1">
			            <p class="leading-none font-medium text-sm mb-1">{{ textHeader }}</p>
			            <p class="leading-none font-medium text-sm">Dernière synchronisation : {{ synchronization }}</p>
		            </div>
	            </div>
            </div>
        </div>
        <div class="pwa-planningables px-1">
            <planning-day v-for="(day) in days" :key="day.id" :day="day.day"
                          :plannings="day.plannings" :absences="day.absences"></planning-day>
        </div>
        <div class="calendar-overlay opacity-100 fixed z-50 w-full h-full" v-if="updating">
            <div class="h-full w-full flex items-center justify-center">
                <md-progress-spinner class="md-white" md-mode="indeterminate"
                                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import PlanningDay from "@/pages/ProgressiveWebApp/Planning/components/PlanningDay";
import { mapState } from "vuex";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

export default {
    name: "PwaPlanning",
    components: {
        PlanningDay
    },
	mixins: [indexedDBMixin],
    data() {
        return {
	        days: [],
            updating: true,
	        synchronization: '',
        }
    },
    computed: {
	    textHeader() {
		    if (!this.updating) {
			    return `Du ${this.$moment(this.days[0].day).format('DD/MM/YYYY')} au ${this.$moment(this.days[(this.days.length - 1)].day).format('DD/MM/YYYY')}`
		    } else {
			    return 'Chargement ...'
		    }
	    }
    },
    methods: {
        async getPlanningData() {
            this.updating = true
	        const planning = await this.fetchDataFromIndexedDB('pwa/planning')
	        this.days = planning.value.days
	        this.updating = false
        }
    },
    mounted() {
	    this.getPlanningData()

	    this.synchronization = JSON.parse(localStorage.getItem('pwa')).synchronization
    }
}
</script>

<style scoped lang="scss">

</style>
